<template>
	<div class="addzz">
		<el-dialog 
			:modal-append-to-body='true'
			width="600px"
			center
			:append-to-body='true'
			@close="closeXinde"
			:visible.sync="show">
			<div slot="title" class="addtitle">
				<div>
					<i class="icon adddzz"></i>
					{{title}}
					<div class="addline"></div>
				</div>
			</div>
			<div class="formData" style="padding-bottom: 40px;">
				<div class="xinde">
					{{content}}
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default{
		data() {
			return{
				title:"思想汇报",
				show:false,
				content:""
			}
		},
		methods:{
			openXinde(content){
				this.content = content;
				this.show = true
			},
			closeXinde(){
				this.show = false
				this.content = "";
			}
		},
		mounted() {
			
		}
	}
</script>

<style lang="scss">
	.formData1{
		width: 100%;
		display: flex;
		justify-content: center;
	}
	.el-dialog__body{
		max-height: 500px !important;
		overflow-y: scroll;
		padding-top: 0px !important;
		margin-top: 0 !important;
	}
	.xinde{
		min-height: 300px;
		overflow-y: scroll;
		line-height: 30px;
		font-size: 14px;
		img{
			width: 50%;
			margin: 20px auto;
		}
	}
</style>
